import { FirearmAssignmentResolverBase } from './firearm-assignment.resolver.base';
import { FirearmAssignmentService } from './firearm-assignment.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FirearmAssignmentResolver extends FirearmAssignmentResolverBase {

  constructor(protected service: FirearmAssignmentService) {
    super(service);
  }
}



